// extracted by mini-css-extract-plugin
export default {"MainContainer":"category_MainContainer__5CM8-","iconContainer":"category_iconContainer__-Oh+q"};